import React, {ReactNode, useMemo, useState} from 'react';
import {Numpad} from '../components/Numpad';
import {useRPC} from "./rpc";
import {useLocalization} from "./localization";

export function useNumpad(disabled: boolean): [() => ReactNode, string, (name: string) => void] {
    const [password, setPassword] = useState('');
    const [rpc] = useRPC();
    const {t} = useLocalization()
    const passwordHash = useMemo(
        () => password.length > 0 ? new Array(password.length).fill('*').join('') : t('pls_enter_password'),
        [password],
    );

    const keyPad = (key: string) => {
        rpc.clickSound();
        if (disabled) {
            if (password !== '') {
                setPassword('');
            }
            return;
        }

        if (key === 'X') {
            if (password.length === 0) {
                return;
            }
            setPassword(password => password.substring(0, password.length - 1));
        } else {
            if (password.length >= 8) {
                return;
            }

            setPassword(password => password + key);
        }
    };

    const renderNumpad = () => {
        return (
            <Numpad hash={passwordHash} onKeyPress={keyPad}/>
        );
    };

    return [renderNumpad, password, setPassword];
}
